import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const ErrorRoute = () => {
    const navigate = useNavigate();

    useEffect(() => { 
      return navigate('/login');
    })

    return(
        <></>
    )
}